import React from 'react';

const TextField = ({
  handleChange,
  placeholder = 'Placeholder Text',
  label = '',
  name,
  onBlur,
  className = '',
  validationMessage = null,
  additionalMessage,
  value,
  disabled = false,
  validationError,
  type = 'text',
}) => {
  const onChange = (e) => {
    if (handleChange instanceof Function) handleChange(e.target.value);
  };

  return (
    <>
      <label
        className={`u-weight--semibold ${
          !label.length && label.length < 1 ? 'u-hidden' : ''
        }`}
        htmlFor={name}
      >
        {label || name}
      </label>

      <input
        className={`c-form__input c-form__input--secondary ${
          validationError ? 'error' : ''
        }`}
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={disabled}
      />

      {additionalMessage && (
        <p className="c-form__additional-message u-mt-3 u-mb-0">
          {additionalMessage}
        </p>
      )}

      {validationError && (
        <p className="c-form__error u-weight--semibold u-mb-0">
          {validationMessage}
        </p>
      )}
    </>
  );
};

export default TextField;
